<!-- Text Settings -->
@if (isTextWidget) {
  <div>
    <div class="form-group">
      <label translate>Select data source</label> <br>
      <div class="form-check d-inline-block mr-3">
        <input (click)="setIsUsingLiveDataAsSource()"
          [checked]="!userDefinedWidget.userDefinedChartDetails.usingStaticData"
          class="form-check-input"
          id="radio_live_data"
          type="radio">
          <label class="form-check-label" for="radio_live_data" translate>Live data</label>
        </div>
        <div class="form-check d-inline-block">
          <input (click)="setIsUsingStoredDataAsSource()"
            [checked]="userDefinedWidget.userDefinedChartDetails.usingStaticData"
            class="form-check-input"
            id="radio_stored_data"
            type="radio">
            <label class="form-check-label" for="radio_stored_data" translate>Stored data</label>
          </div>
        </div>
        @if (!userDefinedWidget.userDefinedChartDetails.usingStaticData) {
          <div>
            <scitis-widget-configuration-signals-selector
              (signalSelectionChanged)="onSignalSelected($event)"
              [items]="allUsableSignals"
              [multiSelection]="true"
              [selectedSignalsIds]="selectedSignalIds"
              [showColor]="false"
              [validate]="false">
            </scitis-widget-configuration-signals-selector>
            <span class="form-label" translate>Selected signals</span>
            @if (!userDefinedWidget.userDefinedChartDetails.signals || userDefinedWidget.userDefinedChartDetails.signals.length===0) {
              <div
                class="alert alert-info text-center">
                <span translate>Currently no signals have been added, please add one from above.</span>
              </div>
            }
            <ul [(dragulaModel)]="userDefinedWidget.userDefinedChartDetails.signals" [dragula]="dragAndDropItems"
              class="list-group">
              @for (signal of userDefinedWidget.userDefinedChartDetails.signals; track signal) {
                <li class="list-group-item draggable">
                  <div class="row">
                    <div class="col align-items-center d-flex">
                      <span class="fa-solid fa-grip-vertical mr-2 text-muted"></span>
                      <span [innerText]="signal.label | translate | truncate" class="truncate" [ngClass]="{'signal-deleted': hasSignalBeenDeleted(signal)}"></span>
                      <span [innerHTML]="getSignalUnit(signal)" class="ml-1 text-muted"></span>
                      @if (hasSignalBeenDeleted(signal)) {
                        <em [ngbTooltip]="'The signal does not exist anymore on the asset.'|translate"
                          class="fa-solid fa-circle-question text-muted ml-1"
                        placement="top"></em>
                      }
                    </div>
                    <div class="col-auto align-items-center d-flex">
                      <button (click)="onRemoveSignal(signal)" [title]="'Remove signal'|translate"
                        class="btn btn-xs btn-outline-danger ml-2">
                        <span class="fa-solid fa-trash"></span>
                      </button>
                    </div>
                  </div>
                </li>
              }
            </ul>
          </div>
        }
        @if (hasDeletedSignalsMap.get(userDefinedWidget.id+'') ?? false) {
          <div class="d-flex align-items-center justify-content-center mb-0 mt-2 alert alert-warning text-center">
            <em class="fa-solid fa-circle-exclamation mr-2"></em>
            <span translate>Selected Signal has been deleted in the asset configuration. Please select a new one.</span>
          </div>
        }
        @if (userDefinedWidget.userDefinedChartDetails.usingStaticData) {
          <div>
            <div class="form-group">
              <span class="form-label" translate>Polling rate</span>
              <ng-select (change)="onSetPollingRate($event)"
                [(ngModel)]="selectedPollingRate"
                [items]="pollingRate"
                 [ngClass]="{
                     'is-invalid': !isPollingRateValid,
                       'is-valid': isPollingRateValid
                       }"
                [placeholder]="pollingRatePlaceholder"
                bindLabel="pollingRate"
                bindValue="pollingRateKey">
              </ng-select>
            </div>
            <div class="form-group">
              <span class="form-label" translate>Static data</span>
              @if (isLoadingStaticData) {
                <span class="fa-solid fa-spinner fa-spin ml-2"></span>
              }
              <ng-select (change)="onAddStaticData($event)"
                [(ngModel)]="selectedStaticData"
                [closeOnSelect]="false"
                [disabled]="isLoadingStaticData"
                [items]="storedData"
                [multiple]="true"
                 [ngClass]="{
                     'is-invalid': !isStaticDataValid,
                       'is-valid': isStaticDataValid
                       }"
                [placeholder]="staticDataPlaceholder">
                <ng-template let-clear="clear" let-items="items" ng-multi-label-tmp>
                  @if (items.length > 0) {
                    <div class="ng-value">
                      <span class="ng-value-label">
                        <strong [innerHTML]="items.length"></strong> &nbsp;
                        <span translate>Static data selected</span>
                      </span>
                    </div>
                  }
                </ng-template>
              </ng-select>
            </div>
            <span class="form-label" translate>Selected static data</span>
            @if (!isStaticDataValid) {
              <div class="alert alert-info text-center">
                <span translate>Currently no static data have been added, please add one from above.</span>
              </div>
            }
            <ul [(dragulaModel)]="userDefinedWidget.userDefinedChartDetails.staticData" [dragula]="dragAndDropStaticItems"
              class="list-group">
              @for (data of userDefinedWidget.userDefinedChartDetails.staticData; track data) {
                <li class="list-group-item draggable">
                  <div class="row">
                    <div class="col align-items-center d-flex">
                      <span class="fa-solid fa-grip-vertical mr-2 text-muted"></span>
                      <span [innerText]="data | truncate" class="truncate"></span>
                    </div>
                    <div class="col-auto align-items-center d-flex">
                      <button (click)="onRemoveData(data)" [title]="'Remove meta data'|translate"
                        class="btn btn-xs btn-outline-danger ml-2">
                        <span class="fa-solid fa-trash"></span>
                      </button>
                    </div>
                  </div>
                </li>
              }
            </ul>
          </div>
        }
      </div>
    }
